import { observable, action } from 'mobx';
import { saveAs } from 'file-saver';
import { http } from 'libs';
import { message } from 'antd';
// import moment from "moment";

class Store {
  @observable records = [];
  @observable record = {};
  @observable stockOutItemList = [];
  @observable expressList = [];
  @observable fetching = false;
  @observable formVisible = false;
  @observable formLoading = false;
  @observable selectDisable = false;
  @observable formWmsVisible = false;
  @observable formLogVisible = false;
  //搜索条件
  @observable page = 1;
  @observable pageSize = 10;
  @observable pageTotal = 0;
  @observable projectNo = null;
  @observable purchaseNo = null;
  @observable brandName = null;
  @observable goodsName = null;
  @observable catalog = null;
  @observable applyUserName = null;
  @observable invoiceTitle = null;
  @observable factoryCode = null;
  @observable updateTime = null;
  @observable projectList = [];
  @observable typeObj = {
    "Sale": "销售",
    "Rent": "租赁",
    "Store": "仓储",
    "Testing": "计量",
    "Transfer": "转运",
  };


  // constructor() {
  //   initStore(this, makeAutoObservable)
  // }

  pageChange = (page, size) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    // localStorage.setItem('orderPageSize',size);
    this.fetchRecords()
}

fetchRecord = (info) => {
  this.projectList = [];
  this.formLoading = true;
  let query = {
    orderItemId: info.orderItemId,
    catalog: info.catalog

  }
  http.get('/javaApi/front/project/listAll',{ params: {orgId:info.orgId} })
  .then(action('a', res => {
    this.projectList = res.data.result; 
}))
  http.get('/javaApi/front/clinicalOrder/getDetail',{ params: query })
    .then(action('a', res => {
      this.record = res.data.result; 
  }))
    .finally(action('b', () => this.formLoading = false))
};

  fetchRecords = () => {
    this.fetching = true;
    let query = {
      catalog: this.catalog, // 订单类型(销售Sale/租赁Rent/仓储Store/计量Testing/转运Transfer)
      brandName: this.brandName, // 品牌
      goodsName: this.goodsName, // 产品
      factoryCode: this.factoryCode, // 货号
      projectNo: this.projectNo, // 项目号
      invoiceTitle: this.invoiceTitle, // 发票抬头
      applyUserName: this.applyUserName, // 申请人ID
      purchaseNo: this.purchaseNo, // PO号
    }
    http.post('/javaApi/front/clinicalOrder/list',{ 
      pageNo: this.page,
      pageSize: this.pageSize,
      param: query 
    })
      .then(action('a', res => {
        console.log(res);
        this.records = res.data.result.data
        this.pageTotal = res.data.result.pageInfo.totalRows;
    }))
      .finally(action('b', () => this.fetching = false))
  };

  async exportLog(data,isDetail) {

    let url = isDetail?'/javaApi/front/export/orderDeviceExcel':'/javaApi/front/export/orderExcel';
    const res = await http({
      url: url,
      method: 'get',
      params:data,
      responseType: 'arraybuffer',
      headers: {
        token: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return res;
  }

  onExport = (isDetail) => {
    const query = { 
      pageNo: this.page,
      pageSize: this.pageSize,
      catalog: this.catalog, // 订单类型(销售Sale/租赁Rent/仓储Store/计量Testing/转运Transfer)
      brandName: this.brandName, // 品牌
      goodsName: this.goodsName, // 产品
      factoryCode: this.factoryCode, // 货号
      projectNo: this.projectNo, // 项目号
      invoiceTitle: this.invoiceTitle, // 发票抬头
      applyUserName: this.applyUserName, // 申请人ID
      purchaseNo: this.purchaseNo, // PO号
    }
    this.exportLog(query,isDetail).then(res => {
      if (res) {
        let url = window.URL.createObjectURL(
          new Blob([res.data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          }),
        );
        saveAs(url,isDetail?'订单明细列表.xls':'订单列表.xls');
      } else {
        message.error('导出失败');
      }
    });
  }

  async fetchOrgList(value) {
    const query = {
      name: value,
    }
    return http.get('/api/customer/organization/',{ params: query })
    // .then((response) => response.json())
      .then((res) =>{
        console.log(res);
        if (res&&res.length) {
          return res.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        }else{
          return []
        }
      }
      );
  }

  // addLog(id){
  //   http.post('javaApi/common/addVisitLog',{
  //     pageName: "物流详情",
  //     eventCode: "ExportCert",
  //     eventName: "下载送货单",
  //     content: "json字符串，导出的当前数据id"
  //   })
  //     .then(action('a', res => {
  //   }))
  //     .finally(action('b', () =>{}))
  // }

  async fetchCustomerList(value,id) {
    if (id) {
      const query = {
        organization_id: id,
        name: value,
        
      }
      return http.get('/api/customer/customer/',{ params: query })
        .then((res) =>
          res.map((item) => ({
            ...item,
            label: item.name,
            value: item.id, 
          })),
        );
    }
  }

  onRowsChange = (rows, keys) => {
    console.log(rows, keys)
  }

  showForm = (info) => {
    this.fetchRecord(info);
    this.formVisible = true;
  }

  showWmsForm = (info) => {
    this.record = info;
    this.stockOutItemList = info.stockOutItemList || [];
    this.formWmsVisible = true
  }

  showLogistics = (info) => {
    this.expressList = info || [];
    this.formLogVisible = true
  }
}

export default new Store()